import styles from "./EnvironmentalPolicyPage.module.css";

const EnvironmentalPolicyPage = () => {
  return (
    <div className={styles.container}>
      <h1>Περιβαλλοντική Πολιτική</h1>
      <p>
        Η Εταιρεία δεσμεύεται να ικανοποιεί τις απαιτήσεις των πελατών της,
        συμβάλλοντας ταυτοχρόνως στη διαμόρφωση και διατήρηση ενός καθαρού και
        υγιούς περιβάλλοντος. Σε όλα τα στάδια των εργασιών, μέχρι και την
        τελική διάθεση αυτών, η εταιρεία συμβάλλει στην προστασία του
        περιβάλλοντος. Όλο το προσωπικό της είναι ενημερωμένο και ενεργεί με
        πλήρη συναίσθηση της ευθύνης του για την προστασία του περιβάλλοντος.
      </p>

      <h2>Το πεδίο εφαρμογής της εταιρείας είναι:</h2>
      <ul>
        <li>
          Ασφαλής Ψηφιοποίηση Αρχείων Πελατών της Εταιρείας μας σε Έντυπη Μορφή
        </li>
        <li>
          Ασφαλής Φύλαξη Αρχείων Πελατών της Εταιρείας μας σε Έντυπη ή/και
          Ηλεκτρονική Μορφή
        </li>
        <li>
          Ασφαλής Διαχείριση Αρχείων Πελατών της Εταιρείας μας σε Έντυπη ή/και
          Ηλεκτρονική Μορφή:
          <ul>
            <li>Μεταφορά</li>
            <li>Καταγραφή / Καταλογογράφηση</li>
            <li>Αρχειοθέτηση</li>
            <li>
              Προεπισκόπηση και Αναζήτηση Μεταδεδομένων στη Διαχείριση Αρχείων
            </li>
          </ul>
        </li>
        <li>
          Ασφαλής Καταστροφή Αρχείων Πελατών της Εταιρείας μας σε Έντυπη ή/και
          Ηλεκτρονική Μορφή
        </li>
        <li>
          Συμβουλευτικές Υπηρεσίες για τη Διαχείριση Αρχείων (Records
          Management) Πελατών της Εταιρείας μας
        </li>
        <li>Συμβουλευτικές Υπηρεσίες DPO / GDPR</li>
      </ul>

      <h2>Κύριοι στόχοι της περιβαλλοντικής πολιτικής της εταιρείας είναι:</h2>
      <ul>
        <li>
          Η ενημέρωση και εκπαίδευση του προσωπικού της εταιρείας με στόχο την
          ενεργό συμμετοχή του στην εφαρμογή του Συστήματος Περιβαλλοντικής
          Διαχείρισης.
        </li>
        <li>
          Η συμμόρφωση όλων των διαδικασιών και δραστηριοτήτων της εταιρείας με
          την περιβαλλοντική νομοθεσία.
        </li>
        <li>
          Η καλύτερη διαχείριση της ενέργειας, των φυσικών πόρων, των πρώτων και
          βοηθητικών υλών, που απαιτούνται στις εργασίες της εταιρείας.
        </li>
        <li>
          Η πρόληψη της ρύπανσης και των περιβαλλοντικών ατυχημάτων και η μείωση
          των περιβαλλοντικών κινδύνων.
        </li>
        <li>Η συνεχής βελτίωση των περιβαλλοντικών επιδόσεων της εταιρείας.</li>
        <li>
          Η ενημέρωση των πελατών, προμηθευτών και εξωτερικών συνεργατών για την
          ανάπτυξη του Συστήματος Περιβαλλοντικής Διαχείρισης από την εταιρεία.
        </li>
      </ul>

      <h2>
        Στα πλαίσια της περιβαλλοντικής πολιτικής πραγματοποιούνται τα παρακάτω:
      </h2>
      <ul>
        <li>
          Εφαρμογή Συστήματος Περιβαλλοντικής Διαχείρισης σύμφωνα με το πρότυπο
          ISO 14001:2015.
        </li>
        <li>
          Έλεγχος της κατανάλωσης ενέργειας και νερού και ελαχιστοποίηση της
          ατμοσφαιρικής ρύπανσης.
        </li>
        <li>
          Διαχείριση των αποβλήτων που προκύπτουν από την παραγωγική διαδικασία.
        </li>
        <li>
          Χρήση διαφόρων τεχνικών και μεθόδων διαχείρισης έτσι ώστε να μην
          γίνεται διάθεση των υγρών αποβλήτων στο έδαφος.
        </li>
        <li>
          Ετήσιος έλεγχος επίτευξης των στόχων που μπαίνουν στα περιβαλλοντικά
          προγράμματα.
        </li>
      </ul>

      <p>
        Η εταιρεία <strong>THE RECORDS HUB S.A.</strong> συνεχώς αναθεωρεί,
        εκσυγχρονίζει και προσαρμόζει την Περιβαλλοντική της Πολιτική στις νέες
        συνθήκες, η οποία αποτελεί μια δέσμευση για συνεχή βελτίωση και σεβασμό
        προς το περιβάλλον.
      </p>
    </div>
  );
};

export default EnvironmentalPolicyPage;
